import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  searchString?: string | null;
  isMobile?: boolean;
}

// Two distinct empty states share this slot:
//  - an active search that matched nothing → "No results for "<term>"".
//  - a menu with no items at all (e.g. a store that isn't activated yet, whose menus API returns
//    no categories) → a neutral "menu has no items" message.
// Showing the search message when there is no search term renders the confusing 'No results for ""'.
export default function MenuEmptyState(props: Props) {
  const { searchString, isMobile } = props;
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:MenuCategoryList' });

  const prefix = searchString ? 'no_results' : 'empty_menu';

  return (
    <div className={classnames('my-md space-y-md', { 'mx-md': isMobile })}>
      <h4>{t(`${prefix}.title`, { search: searchString })}</h4>
      <p className="text-sm">{t(`${prefix}.desc`)}</p>
    </div>
  );
}
